import $store from '@/modules/FPKG-50000-Vuex/index'; // lists 與axios溝通
import Header from '@/modules/FPKG-10000-Theme/layout/DEFAULT/Header.vue';

const socket = (data: string) => {
  $store.dispatch('calcReply', data);
};
export default { socket };
